import { useModalContainerContext } from 'app/src/modals/ModalContainerContext';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 500,
	} as React.CSSProperties,
	modal: {
		boxShadow: '2px 2px 20px rgba(0, 0, 0, 0.4)',
	} as React.CSSProperties,
};

type Props = {
	children: React.ReactNode;
	style?: React.CSSProperties;
	className?: string;
};

export default function Modal({
	children,
	style,
	className,
}: Props): ReturnType<typeof ReactDOM.createPortal> | null {
	const modalContainer = useModalContainerContext();

	return modalContainer
		? ReactDOM.createPortal(
				<div style={styles.overlay}>
					<div style={{ ...styles.modal, ...(style ? style : {}) }} className={className}>
						{children}
					</div>
				</div>,
				modalContainer,
		  )
		: null;
}
